import { IIconBase } from '..'

const multipleUserHexagonIcon = ({
  color = '#333752',
  height = 24,
  width = 24,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.08 8.58003V15.42C21.08 16.54 20.48 17.58 19.51 18.15L13.57 21.58C12.6 22.14 11.4 22.14 10.42 21.58L4.48 18.15C3.51 17.59 2.91 16.55 2.91 15.42V8.58003C2.91 7.46003 3.51 6.41999 4.48 5.84999L10.42 2.42C11.39 1.86 12.59 1.86 13.57 2.42L19.51 5.84999C20.48 6.41999 21.08 7.45003 21.08 8.58003Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 11C13.2868 11 14.33 9.95681 14.33 8.66998C14.33 7.38316 13.2868 6.34003 12 6.34003C10.7132 6.34003 9.67 7.38316 9.67 8.66998C9.67 9.95681 10.7132 11 12 11Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 16.66C8 14.86 9.79 13.4 12 13.4C12.3815 13.4 12.7505 13.4435 13.1 13.5248'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.2979 15.5079V16.8513C17.2979 16.965 17.336 17.0681 17.4127 17.1524C17.4898 17.2371 17.59 17.2847 17.7058 17.2847C17.8216 17.2847 17.9218 17.2371 17.9989 17.1524C18.0756 17.0681 18.1137 16.965 18.1137 16.8513V14.9288C18.1137 14.9178 18.1125 14.907 18.1102 14.8966C18.1083 14.8693 18.1041 14.8422 18.0976 14.8154L18.0976 14.8154L18.0967 14.8119C18.0676 14.7036 18.0064 14.6129 17.9094 14.5538C17.8476 14.5159 17.7789 14.4954 17.7058 14.4954C17.6673 14.4954 17.6294 14.5011 17.5926 14.5119L17.5926 14.5118L17.5899 14.5127L16.7453 14.7779L16.7453 14.7779L16.7417 14.7791C16.6343 14.8158 16.5512 14.8872 16.5001 14.9888L16.5001 14.9888L16.4996 14.9899C16.4688 15.0523 16.4534 15.1192 16.4534 15.1888C16.4534 15.228 16.4578 15.2669 16.4666 15.3053L16.4664 15.3053L16.468 15.3109C16.4971 15.4192 16.5583 15.51 16.6552 15.569C16.717 15.6069 16.7857 15.6274 16.8589 15.6274C16.8974 15.6274 16.9352 15.6217 16.972 15.6109L16.972 15.611L16.975 15.61L17.2979 15.5079Z'
        fill={color}
        stroke={color}
        strokeWidth='0.3'
        strokeLinejoin='round'
      />
      <path
        d='M14.7645 17.0516L14.7645 17.0516L14.7662 17.0533C14.8293 17.1164 14.9097 17.15 14.9992 17.15C15.0887 17.15 15.1691 17.1164 15.2322 17.0533C15.2953 16.9902 15.3289 16.9098 15.3289 16.8203V16.3305H15.8203C15.9098 16.3305 15.9902 16.297 16.0533 16.2338C16.1164 16.1707 16.15 16.0903 16.15 16.0008C16.15 15.9113 16.1164 15.8309 16.0533 15.7678C15.9902 15.7047 15.9098 15.6711 15.8203 15.6711H15.3289V15.1797C15.3289 15.0902 15.2953 15.0098 15.2322 14.9467C15.1691 14.8836 15.0887 14.85 14.9992 14.85C14.9097 14.85 14.8293 14.8836 14.7662 14.9467L14.7661 14.9467L14.7645 14.9484C14.703 15.0119 14.6711 15.0917 14.6711 15.1797V15.6711H14.1797C14.0902 15.6711 14.0098 15.7047 13.9467 15.7678C13.8836 15.8309 13.85 15.9113 13.85 16.0008C13.85 16.0903 13.8836 16.1707 13.9467 16.2338C14.0098 16.297 14.0902 16.3305 14.1797 16.3305H14.6711V16.8203C14.6711 16.9083 14.703 16.9881 14.7645 17.0516Z'
        fill={color}
        stroke={color}
        strokeWidth='0.3'
      />
    </svg>
  )
}

export default multipleUserHexagonIcon
